import PromoCode from '../../models/reports/promoCodes.model'

let storeContent = utils.generateStore({
   PromoCode,
   promocodes: [],
})

export default {
   state: {
      ...storeContent.state
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      submitForm(ctx, ref) {
         ctx.commit('loading', true)

         setTimeout(() => {
            ctx.commit('loading', false)
         }, 5000);
      },
      async queryPromocodeRedemption(ctx,payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.formData_

            if (await payload.ref.isValid()) {
               let from = moment(`${data.duration[0]} 00:00`, 'DD-MM-YYYY HH:mm').valueOf(), to = moment(`${data.duration[1]} 23:59`, 'DD-MM-YYYY HH:mm').valueOf();
               let res = await api.fetchEndpointSecure({
                  resource: "registration",
                  action: "fetch:promocodes",
                  data: {
                     from,
                     to,
                  },
                  meta_data: {}
               })
               ctx.commit('promocodes', res.result.redemptions)
               console.log(from, to)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      }
   }
};